export default "__VITE_ASSET__BUsaxO7o__"